// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fa7ed29","239":"5c9c2004","453":"8780fd39","455":"e33835c1"}[chunkId] + ".chunk.js";
};